import singleSpaHtml from 'single-spa-html';
import template from './sidebar.html';
import renderMenuItems from './components/menuItems';
import { SIDEBAR_CLASS } from '../../assets/styles/style-helpers';
import { getAppConfig } from '../../utilities/api'
const sidebar = singleSpaHtml({
    template,
});

/**
 * Sets the menu button of the topbar app to toggle the sidebar on click.
 * Also sets the sidebar to close itself when clicking
 * on a menu item or anywhere outside the sidebar.
 */
const _setSidebarToggleListeners = () => {
    const topbarMenuButton = document.getElementById('sidebar-toggle');
    const sidebarMenu = document.getElementById('sidebar');

    topbarMenuButton?.addEventListener('click', () => {
        sidebarMenu?.classList.toggle('is-active');
    });

    window.addEventListener('click', (event) => {
        const links = Array.from(
            document.querySelectorAll(`${SIDEBAR_CLASS.rootId} .${SIDEBAR_CLASS.item} *`)
        );

        if (
            (!topbarMenuButton?.contains(event.target) &&
                !sidebarMenu?.contains(event.target)) ||
            links.includes(event.target)
        ) {
            sidebarMenu?.classList.toggle('is-active', false);
        }
    });
};

/**
 * Extends the default mount lifecycle function to request menu items, populate
 * them in the sidebar component, and wire up event listeners and handlers.
 * @param {*} props Extra options passed in during application registration that allow us access
 * to the `single-spa` API; see the
 * {@link https://single-spa.js.org/docs/building-applications/#built-in-props| single-spa docs} for more details
 * @returns {Promise<void>} A void promise indicating the work is complete
 */
export const mount = async (props) => {
    await sidebar.mount(props);
    const { appSlug, appRootUrl, localesFromDatabase } = props;
    _setSidebarToggleListeners();
    const appConfig = await getAppConfig(appRootUrl, appSlug);
    await renderMenuItems(appConfig, appSlug, localesFromDatabase);
};

export const { bootstrap, unmount } = sidebar;
